import { QueryClient } from "@tanstack/react-query";
import { planningTemplateQueryKey } from "Planning/PlanningTemplate";
import { itineraryShowsSidebarQueryKey, itinerarySidebarQueryKey } from "show/ItinerarySidebar/base";
import { listTemplateQueryKey } from "components/ListTemplate";

export const invalidateGroundTransportsCache = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: [listTemplateQueryKey, "groundTransport_List"] });
  queryClient.invalidateQueries({ queryKey: [itinerarySidebarQueryKey] });
  queryClient.invalidateQueries({ queryKey: [itineraryShowsSidebarQueryKey] });
  queryClient.invalidateQueries({ queryKey: [planningTemplateQueryKey] });
  queryClient.invalidateQueries({ queryKey: ["linkedTravel"] });
}